import React from 'react';
import PropTypes from 'prop-types';
import Utils from './../../Utils/Utility';
let logoSrc = require('../../../img/wl-logo.png');

import './../../../sass/components/modal.scss';

const Modal = ({ children, customClass, headerCustomClass, show, closeCallback, title, order }) => (
    <div className={`modal ${customClass}`} style={{ display: show ? 'block' : 'none'}}>
        <div className="overlay"></div>
        <div className="modal_content">
            <div className={`${headerCustomClass}`}>
                <div className={"modal-img-left"}>
                    <img style={{width : 120}} src={logoSrc} alt=""/>
                </div>

                <div className="modal-title-center">
                    <h3 className="modal-title"><b>{title}</b></h3>
                    {
                        !Utils.isEmptyObj(order) && !Utils.isEmpty(order.orderNum)? (
                            <h3 className="text-center ordernum-text">#{order.orderNum}</h3>
                        ) : null
                    }
                </div>

                <div className="modal-close-btn">
                    <button title="Close" className="close_modal" onClick={closeCallback}>
                        <i className="fa fa-times"></i>
                    </button>
                </div>
            </div>
            {children}
        </div>
    </div>
);

Modal.propTypes = {
    children: PropTypes.element,
    customClass: PropTypes.string,
    show: PropTypes.bool,
    closeCallback: PropTypes.func,
};

Modal.defaultProps = {
    children: <div>Empty Modal</div>,
    customClass: '',
    show: false,
    closeCallback: () => (false)
};

export default Modal;



// WEBPACK FOOTER //
// src/components/generic/modal.js